// extracted by mini-css-extract-plugin
module.exports = {"container":"nav-header_container__37RQI","itemContainer":"nav-header_itemContainer__3jDa2"};